import { useEffect, useState, MouseEvent, ReactNode } from 'react'
import classNames from 'classnames/bind'

import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'

import PlainIcon, { iconType, iconColor } from '../plain-icon'
import styles from './plain-side-slider.module.scss';


const cx = classNames.bind(styles)

type Props = {
  children: ReactNode
  open: boolean
  onCrossClick: (e: MouseEvent<HTMLButtonElement>) => void
  position: {
    top: number
    right: number
    bottom: number
  }
  className?: string
  classNameOpened?: string
}

export const PlainSideSlider = ({
  children,
  open,
  onCrossClick,
  position,
  className,
  classNameOpened,
}: Props) => {
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    if (!open) {
      setTimeout(() => {
        setMounted(false)
      }, 450)
      return
    }
    setMounted(true)
  }, [open])

  const classNameRoot = cx(
    styles.root,
    { [classNameOpened || 'open']: open },
    className,
  )

  return (
    <div className={classNameRoot} style={position}>
      <PlainButtonAsLink onClick={onCrossClick} className={styles.cross}>
        <PlainIcon
          width={16}
          height={16}
          className={styles.icon}
          type={iconType.CROSS_BOLD}
          colorType={iconColor.COLOR_GRAY}
        />
      </PlainButtonAsLink>
      {mounted && children}
    </div>
  )
}
